import { useCallback } from 'react'

import { useSetFocus } from '@please/lrud'
import { useLocation, useNavigate } from 'react-router-dom'

import { focusIds } from '@/constants/focus'
import { paths } from '@/constants/paths'
import { popupStatus } from '@/constants/popup'
import useStore from '@/store/useStore'
import { sendPageViewEvent } from '@/utils/analyticsUtils'
import { getMainHomePath } from '@/utils/route'
import { isWebos, sendPageImpressionToGTAG } from '@/utils/utils'

const useBackNavHistory = true

export const useOpenPrevEventPopup = () => {
  const setFocus = useSetFocus()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const useBackNav = !isWebos() && useBackNavHistory

  return useCallback(() => {
    const isEventUrl = pathname?.includes(paths.EVENT_PAGE)

    const state = useStore.getState()
    const { currentEvent, setCurrentEvent, openPrevEvent, setListPopup } =
      state.common
    const { pagePopup, pagePopupStatus } = state.popup

    const isPagePopupOpen = pagePopupStatus !== popupStatus.CLOSED

    currentEvent?.listOptions && setListPopup(currentEvent.listOptions)

    if (currentEvent?.prevEvent && useBackNav) {
      return openPrevEvent()
    }

    if (isEventUrl) {
      const mainPath = getMainHomePath()

      navigate(mainPath)
      sendPageViewEvent(mainPath)
      sendPageImpressionToGTAG(mainPath)
      return setCurrentEvent(null)
    }

    setCurrentEvent(null)

    let path = pathname
    let focusId = `${focusIds.CONTENT}`

    if (currentEvent?.listOptions) {
      path = `${paths.LIST}/${currentEvent.listOptions.listContextId}/${currentEvent.listOptions.name}`
      focusId = `${focusIds.PAGE_POPUP}${focusIds.LIST}${focusIds.CONTAINER_MOD}`
    } else if (isPagePopupOpen) {
      path = `${paths.PAGE}/${pagePopup?.id}`
      focusId = `${focusIds.PAGE}_${focusIds.POPUP}${focusIds.CONTAINER_MOD}`
    }

    sendPageViewEvent(path)
    sendPageImpressionToGTAG(path)

    setFocus(focusId)
  }, [setFocus, pathname, navigate])
}
